<template>
  <BLayoutExpansion title="Основное">
    <v-row dense align="center">
      <v-col cols="12" lg>
        <BTextField
          v-model="form.username"
          :validate="{
            required: true,
            regex: [/^[a-zA-Z\-_\d]+$/, `Ошибка. ${usernameHelper}`]
          }"
          label="Логин"
          :disabled="isView || isProfile"
          :skeleton="skeleton"
          name="username"
          autofocus
        >
          <template #append>
            <BInfo :text="usernameHelper" />
          </template>
        </BTextField>
      </v-col>

      <v-col v-if="isEdit" cols="auto">
        <v-skeleton-loader :loading="skeleton" type="button">
          <v-btn text small color="info" @click="$emit('change-password')">
            Сменить пароль
          </v-btn>
        </v-skeleton-loader>
      </v-col>

      <v-col cols="12" :lg="isEdit ? void 0 : 7">
        <BTextarea
          v-model="form.full_name"
          validate="required"
          label="ФИО"
          :rows="1"
          :disabled="isView"
          :skeleton="skeleton"
          name="full_name"
        />
      </v-col>
    </v-row>

    <v-row v-if="isCreate" dense>
      <v-col cols="12" lg="6">
        <BTextFieldPassword
          ref="password"
          v-model="form.password"
          :skeleton="skeleton"
          validate="required"
          label="Пароль"
          name="password"
        />
      </v-col>

      <v-col cols="12" lg="6">
        <BTextFieldPassword
          v-model="passwordRepeat"
          :skeleton="skeleton"
          :validate="{
            required: true,
            confirmBy: {
              field: '«Пароль»',
              value: form.password,
            },
          }"
          label="Повторите пароль"
        />
      </v-col>
    </v-row>

    <v-row v-if="!isCreate && ('created_at' in form)" dense>
      <v-col cols="12" :lg="!skeleton && 'auto'">
        <BTextField
          :value="form.created_at | dateFormatter"
          :skeleton="skeleton"
          label="Создан"
          disabled
        />
      </v-col>

      <v-col cols="12" :lg="!skeleton && 'auto'">
        <BTextField
          :value="form.updated_at | dateFormatter"
          :skeleton="skeleton"
          label="Обновлен"
          disabled
        />
      </v-col>
    </v-row>
  </BLayoutExpansion>
</template>

<script>
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BTextarea from '@/components/forms/BTextarea.vue'
import BTextFieldPassword from '@/components/forms/BTextFieldPassword.vue'
import BInfo from '@/components/common/BInfo.vue'


const usernameHelper = 'Может содержать только латинские буквы нижнего регистра, числа, дефис (-) и (_) нижнее подчёркивание'

export default {
  name: 'UsersFormMain',
  components: {
    BLayoutExpansion,
    BTextField,
    BTextarea,
    BTextFieldPassword,
    BInfo,
  },
  props: {
    isCreate: Boolean,
    isEdit: Boolean,
    isView: Boolean,
    isProfile: Boolean,
    skeleton: Boolean,
    form: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    passwordRepeat: void 0,
    usernameHelper,
  }),
  methods: {
    onReset() {
      this.passwordRepeat = void 0
    },
  },
}
</script>
